import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_LOCAL_CANCEL_FEE_TRANSFER_ACCEPT_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION =
	graphql(/* GraphQL */ `
		mutation ReservationLocalCancelFeeTransferAcceptForManagementReservationItemDetailUpdate(
			$input: ReservationLocalCancelFeeAcceptInput!
		) {
			reservationLocalCancelFeeTransferAccept(input: $input) {
				reservationDetail {
					canHandleLocalPaymentCancelFee
					canUpdate
					statusReservation
					localCancelFeeTransferDate
					localCancelFeeTransferAccountName
				}
				userErrors
			}
		}
	`);
